import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'dialog' ]

  currentDialog;

  connect() {
    this.currentDialog = null;
  }

  disconnect() {
    if(this.currentDialog) this.disposeDialog();
  }

  dialogTargetConnected(dialog) {
    if(this.currentDialog) {
      this.disposeDialog();
    }

    this.currentDialog = dialog;
    dialog.showModal();
    dialog.addEventListener('click', e => this.#closeOnClick(e));
  }

  disposeDialog() {
    this.currentDialog.removeEventListener('click', e => this.#closeOnClick(e));
    this.currentDialog.close();
    this.currentDialog.remove();
    this.currentDialog = null;
  }

  #closeOnClick = e => {
    if(!this.currentDialog) return;

    if(e.target === this.currentDialog) {
      this.disposeDialog()
      e.preventDefault();
    }
  }
}
